import http from '@/http'
const URL = '/admin/languages'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    one = (await http.get(URL + `/${id}`))
  }
  return one
}

export const save = (payload) => {
  if (payload.id) {
    return http.put(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const toggleStatus = async (id) => http.put(URL + `/${id}/status`)

export const setDefault = async (id) => http.put(URL + `/${id}/default`)

export const updateOrder = async (payload) => http.put(URL + `/order`, payload)

export const deleteLanguage = async (id) => http.delete(URL + `/${id}`)

export default {
  list,
  show,
  save,
  toggleStatus,
  setDefault,
  updateOrder,
  deleteLanguage
}
